<body>
    <div class="dash">
        <!-- Patient sidebar start here -->
      <!-- <app-patsidebar></app-patsidebar> -->
        <!-- Patient sidebar end here -->
        <div class="dash-app">
            <!-- Patient Header start here -->
            <!-- <app-patheader></app-patheader> -->
        
            <!-- Patient Header end here -->

            <!-- Patient Main Body start here -->
<div class="container">
    <div class="col-md-12">
        <div class="row">
            <div class="col-md-4"> <img class="dokimage" [src]=" serverip + '/' + dokData?.profileImage" alt="">
            </div>
              <div class="col-md-4">
                <h3 style="color: rgb(0, 0, 0);">
                    Dr 
                <span style="font-size: 40px;color:#d63031">{{dokData?.name}}</span> 
                </h3> 
            </div>
            <div class="col-md-4"> <button class="btn btn-primary">BOOK APPOINTMENT</button>
            </div>
        </div>
    </div>  
</div>
<div class="container">
    <div class="col-md-12">
     <div class="row">
         <div class="col-md-6">
            <h6>Verified Medical Council Id: &nbsp;  <b style="color: turquoise;">{{dokData?.mcId}}</b></h6>
            <h6>Membership:&nbsp; <b style="color: turquoise;">{{dokData?.membership}}</b></h6>
            <h6>Degree: &nbsp; <b style="color: turquoise;">{{dokData?.degree}}</b></h6>
            <h6>ConsultationFee:&nbsp; <b style="color: turquoise;">{{dokData?.consultationFee.firstVisit}}</b></h6>
            <h6>Attending TOKEN NO:</h6>
         </div>
         <div class="col-md-6">
            <h6>doctorType:&nbsp; <b style="color: turquoise;">{{dokData?.doctorType.name}}</b></h6>

            <h6>Address:&nbsp; <b style="color: turquoise;">{{dokData?.address.line1}} &nbsp;{{dokData?.address.city}} &nbsp;{{dokData?.address.pincode}} &nbsp;{{dokData?.address.district}} &nbsp;{{dokData?.address.state}}</b></h6>

         </div>
     </div>
    </div> 
    <div class="bs-example">
        <ul class="nav nav-tabs">
            <li class="nav-item" *ngFor="let clinic of dokData; let index = index">
                <!-- [ngClass]="{ active: index == curIndex }" -->
                <a [href]="'#' + index" (click)="changeclinic(index, dokData[index]?._id)" class="nav-link"  data-toggle="tab">
    {{ clinic?.clinicName }}
    <h6 style="color: rgb(21, 192, 135);">{{clinic?.clinicStatus}}</h6> </a>
</li>
        </ul>
        <div class="tab-content clinic-content">
            <div class="tab-pane fade show active" id="{{ curIndex }}">
                <div class="row">
                    <div class="col-md-4">
                        <img [src]=" serverip + '/' + (dokData[curIndex]?.clinicImages)[0]" class="img-thumbnail" style="height: 240px;width:100%;" *ngIf="(dokData[curIndex]?.clinicImages)[0]" />
                        <img src="../../../assets/clinic1.jpg" class="img-thumbnail" style="height: 240px;width:100%;" *ngIf="!(dokData[curIndex]?.clinicImages)[0]" />
                    </div>
                    <div class="col-md-4">
                        <h4 class="mt-2">{{ dokData[curIndex]?.clinicName }}</h4>
                        <div>
                            <p>
                                <i class="fa fa-clock-o"></i> {{ dokData[curIndex]?.timming.startTime }} -
                                <i class="fa fa-clock-o"></i> {{ dokData[curIndex]?.timming.endTime }}                            </p>
                            <p>
                                <i class="fa fa-map-marker"></i> {{ dokData[curIndex]?.address?.line1 }} {{ dokData[curIndex]?.address?.city }} {{ dokData[curIndex]?.address?.district }} {{ dokData[curIndex]?.address?.state
                                }}- {{ dokData[curIndex]?.address?.pincode }}
                            </p>
                            <p>
                                <span>Weekly Availability : </span>
                                <span class="badge badge-success" style="margin-right: 5px;" *ngFor="let wd of dokData[curIndex]?.weekDays">{{ wd.slice(0, 3) }}</span
          >
        </p>
      </div>
    </div>
>
                    </div>
                </div>
     
            </div>
            
           
        </div>
</div>
       <!-- Patient Main Body end here-->
        </div>
    </div>
</body>